export default {
  container: {
    width: '100px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '100px 0 0'
  }
}
